export const problemasMargemContent = {
  heading: "OS PROBLEMAS\nQUE CORROEM\nA MARGEM",
  intro:
    "Mesmo em operações tecnicamente\nevoluídas, a rentabilidade ainda é\nimpactada por falhas operacionais que\npassam despercebidas no dia a dia.",
  items: [
    "Suplementação fora da frequência ideal",
    "Consumo acima ou abaixo do planejado",
    "Desvios de GMD percebidos só meses depois",
    "Pastos ocupados fora da janela ideal",
    "Falhas na gestão de lotes e movimentações",
  ],
} as const;
